import { render, staticRenderFns } from "./Kyc-data.vue?vue&type=template&id=28acea75&scoped=true&"
import script from "./Kyc-data.vue?vue&type=script&lang=js&"
export * from "./Kyc-data.vue?vue&type=script&lang=js&"
import style0 from "./Kyc-data.vue?vue&type=style&index=0&id=28acea75&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28acea75",
  null
  
)

export default component.exports